import {useState, useRef, useEffect} from 'react';

import { Overlay, Popover } from 'react-bootstrap';

import './RolloverMenu.scss'

interface IRolloverMenu {
    show: boolean;
    target: any;
    onHide: () => void;
    placement: any;
    className?: string;
}

const RolloverMenu: React.FC<IRolloverMenu> = (props) => {

    const [show, setShow] = useState(props.show);

    const [target, setTarget] = useState(null);

    const ref = useRef(null);

    useEffect(() => {
        if (props.target) {
            setShow(props.show);
            setTarget(props.target.current);
        }
    }, [props.show])

    let className = 'roll_over_menu'
    if (props.className) {
        className += ' ' + props.className
    }

    return (
        <div ref={ref} className={className}>

            <Overlay
                show={show}
                target={props.target}
                placement={props.placement}
                container={ref.current}
                containerPadding={20}
                onHide={() => props.onHide()}
                rootClose={true}
            >
                <Popover id="popover-contained">
                    {/* <Popover.Title as="h3">Popover bottom</Popover.Title> */}
                    <Popover.Content>
                        {props.children}
                    </Popover.Content>
                </Popover>

            </Overlay>
        </div>
    );
}

export default RolloverMenu;